export enum NameChangeRequestStatus {
  NEW = "NEW",
  APPROVED = "APPROVED",
  SUCCESS = "SUCCESS",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
}

export function isNameChangeApprovedStatus(
  status: string | null | undefined
): boolean {
  return (
    status === NameChangeRequestStatus.APPROVED ||
    status === NameChangeRequestStatus.SUCCESS
  );
}

export function isNameChangeRejectedStatus(
  status: string | null | undefined
): boolean {
  return (
    status === NameChangeRequestStatus.REJECTED ||
    status === NameChangeRequestStatus.FAILED
  );
}
